<div class="search"></div>
<recent-chat-search />
<div class="title">
  <p>Recent Chats</p>
</div>
<div class="chats-list">
  @for (chat of chatsList.value(); track chat.chat_id) {
    <a class="chat-item" [routerLink]="`/chat/${chat.chat_id}`" routerLinkActive="active-link">
      {{ chat.name }}
    </a>
  }
</div>
